import React from "react";
import ProductType from "../dtos/product.types";
import styles from "../styles/SecondHomeProducts.module.scss";

import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps, } from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';

import residencial from "../../public/svg/produtos/residencial.svg"
import bike from "../../public/svg/produtos/bike.svg"
import auto from "../../public/svg/produtos/auto.svg"
import empresarial from "../../public/svg/produtos/empresarial.svg"
import odontologico from "../../public/svg/produtos/odontologico.svg"
import vida from "../../public/svg/produtos/vida.svg"
import arrowSecondProd from "../assets/images/arrowSecondRight.svg"

import liberty from "../assets/images/liberty.svg"
import alpha from "../assets/images/alpha.svg"
import bradesco from "../assets/images/bradesco.svg"
import sura from "../assets/images/sura.svg"
import logoMadatech from "../assets/images/logo.svg"

import people from "../../public/svg/produtos/brother.svg"
import celphone from "../assets/images/cel.svg"

import Link from "next/link";

type Props = {
  dataProd: ProductType
}

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
  marginTop: '15px!important',
  border: '1px solid #707070',
  borderRadius: '15px',
  textAlign: 'left',
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(({ theme }) => ({
  marginTop: '0px',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(10),
  },
}));

const SecondHomeProducts = ({ dataProd }: Props) => {
  const [counter, setCounter] = React.useState(2);
  const [token, setToken] = React.useState(false)
  const [expanded, setExpanded] = React.useState<string | false>('');

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => { setExpanded(newExpanded ? panel : false); };

  const nav = dataProd.questions.slice(0, counter).map((question: any) => (
    <div key={question.id}>
      <Accordion expanded={expanded === question.id} onChange={handleChange(question.id)}>
        <AccordionSummary aria-controls="tabProducts" id="tabProducts">
          <Typography className={styles.tituloCollapse}>{question.title}</Typography>
        </AccordionSummary>
        <div className={styles.areaResposta}>
          <Typography className={styles.firstQuestion}>{question.firstText}</Typography>
          <Typography className={styles.secondQuestion} >{question.secondText}</Typography>
          <Typography className={styles.thirdQuestion}>{question.thirdText}</Typography>
        </div>
      </Accordion>
    </div>
  ));

  const verMais = () => {
    setCounter(s => s = dataProd.questions.length)
  };

  React.useEffect(() => {
    if (sessionStorage.token) {
      setToken(true)
    }
  })


  const content =
    dataProd.id == 'residencial'
      ? <img src={residencial} alt={"Celular com casa representando a contratação do Seguro Residencial do Madaseg pelo celular e web."} />
      : dataProd.id == 'bike' ? <img src={bike} alt={"Rapaz sobre uma bicicleta que sai da tela de celular como referência ao Seguro Bike do Madaseg"} />
        : dataProd.id == 'vida' ? <img src={vida} alt={"Celular em destaque com ícone de um coração na tela para representar o Seguro Vida do Madaseg"} />
          : dataProd.id == 'empresarial' ? <img src={empresarial} alt={"Celular em destaque com ícone de empresa sobre ele para representar o Seguro Empresarial do Madaseg"} />
            : dataProd.id == 'odontologico' ? <img src={odontologico} alt={"Celular em destaque com ícone de um dente na tela para citar o Seguro Odontológico do Madaseg"} />
              : <img className="-mt-5 mb-5" src={auto} alt={"Carro em cima da tela de celular para citar o Seguro Auto do Madaseg"} />

  const contentSeguradora =
    dataProd.id == 'residencial'
      ? <img src={liberty} alt={`Logo Liberty seguradora`} />
      : dataProd.id == 'bike' ? <img src={sura} alt={`Logo Sura seguradora`} />
        : dataProd.id == 'vida' ? <img src={liberty} alt={`Logo Liberty seguradora`} />
          : dataProd.id == 'empresarial' ? <img src={alpha} alt={`Logo Alpha seguradora`} />
            : dataProd.id == 'odontologico' ? <img src={bradesco} alt={`Logo Bradesco plano odontológico`} />
              : <img className="-mt-5 mb-5" src={logoMadatech} alt={`Logo Madatech`} />

  const cardCoberturas = dataProd.coberturas.map((c) => (
    <div className={styles.card} key={c.id}>
      <div className={styles.areaCard}>
        <span className={styles.areaNumber}></span>
        <span className={styles.number}>{c.id}</span>
        <span className={styles.textTitulo}>{c.title}</span>
      </div>
    </div>
  ));

  return (
    <section id="SecondHomeProduto" className="relative">
      <div className="grid grid-cols-1">
        <div>
          <Link passHref href={'#p'}><a href=''><span className={styles.arrowConjImage}></span></a></Link>
        </div>
        <div>
          <div className={styles.arrowImage}>
            <div className="2xl:mt-2 mt-12 dlg:mb-28" id="p"></div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-5 items-center content-center">
        <div className="col-span-5 dlg:place-self-center">
          <div className="flex flex-col dlg:flex-row mt-12">
            <span className={styles.titulo}>{dataProd.frasesMid.um}</span>
            <span className={styles.tituloColor}>{dataProd.frasesMid.dois}</span>
          </div>
        </div>
        <div className="col-span-5 dlg:place-self-center dlg:mt-12 mt-8 mb-24">
          <div className="flex flex-col dlg:text-center">
            <span className={styles.fraseTres}>{dataProd.frasesMid.tres}</span>
            <span className={styles.fraseQuatro}>{dataProd.frasesMid.quatro}</span>
            <span className={styles.fraseCinco}>{dataProd.frasesMid.cinco}</span>
          </div>
        </div>
        <div className="dlg:col-span-2 col-span-5 dlg:place-self-center mb-12">
          <div className="flex items-center dlg:justify-center ">
            <div className={styles.arrow}>
              <img src={arrowSecondProd} alt="flecha coberturas" />
            </div>
            <div className="flex dlg:flex-col sm:flex-row">
              <span className={styles.textCobertura}>Coberturas</span>
              <span className={styles.textPrincipal}>principais</span>
            </div>
          </div>
          <div className={styles.areaCobertura}>
            <span className={styles.fraseCobertura}>{dataProd.fraseCoberturas}</span>
          </div>
        </div>
        <div className="dlg:col-span-3 col-span-5 place-self-center dlg:ml-12 mb-24">
          <div className="grid gap-x-6 gap-y-3 dlg:grid-cols-3 md:grid-cols-4 sm:grid-cols-2">
            {cardCoberturas}
          </div>
        </div>
        <div className="dlg:col-span-2 col-span-5 dlg:place-self-center mb-12">
          <div className="flex items-center dlg:justify-center ">
            <div className={styles.arrow}>
              <img src={arrowSecondProd} alt="flecha coberturas" />
            </div>
            <div className="flex dlg:flex-col sm:flex-row">
              <span className={styles.textCobertura}>Para</span>
              <span className={styles.textPrincipal}>Contratar</span>
            </div>
          </div>
        </div>
      </div>
      <div className="grid dlg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-12 dlg:w-11/12 mx-auto mb-24 dlg:mt-12 mt-8">
        <div className="place-self-center w-full">
          <div className={styles.cardContratar}>
            <div className="2xl:w-3/4 w-2/3 mx-auto">
              <div className={styles.imageProduto}>
                {content}
              </div>
            </div>
            <div className="flex flex-col -mt-3">
              <span className={styles.contratarText}>1. Escolha <span className={styles.contratarTextColor}>o plano</span></span>
              <span className={styles.contratarSecondText}>Escolha o plano ideal para você e sua família.</span>
            </div>
          </div>
        </div>
        <div className="place-self-center w-full">
          <div className={styles.cardContratar}>
            <div className="2xl:w-3/4 w-2/3 mx-auto">
              <div className={styles.imageProduto}>
                <img src={celphone} alt="Imagem segunda etapa contratação" />
              </div>
            </div>
            <div className="flex flex-col -mt-3">
              <span className={styles.contratarTextColor}><span className={styles.contratarText}>2.</span> Pagamento</span>
              <span className={styles.contratarSecondText}>Insira os dados de pagamento.</span>
            </div>
          </div>
        </div>

        <div className="place-self-center w-full">
          <div className={styles.cardContratar}>
            <div className="2xl:w-3/4 w-2/3 mx-auto">
              <div className={styles.imageProduto}>
                <img src={people} alt="Imagem terceira etapa contratação" />
              </div>
            </div>
            <div className="flex flex-col -mt-3">
              <span className={styles.contratarTextColor}><span className={styles.contratarText}>3.</span> Pronto!</span>
              <span className={styles.contratarSecondText}>Cadastro realizado com sucesso.</span>
            </div>
          </div>
        </div>

      </div>
      {token &&
        <div className="grid dlg:grid-cols-3 gap-12 w-11/12 dlg:content-center dlg:mx-auto mb-24 dlg:mt-12">
          <div className="dlg:w-full text-left flex dlg:justify-center dlg:items-center">
            <span className={styles.textFinalContratar}>Confira nosso <span className={styles.textFinalContratarColor}>manual do segurado</span></span>
          </div>
          <div className="dlg:place-self-center">
            {contentSeguradora}
          </div>
          <div className="dlg:w-full flex dlg:justify-center dlg:items-center dlg:text-center">
            {dataProd.id == 'vida' ?
              <div className="flex flex-col">
                <Link passHref href={dataProd.manual ? dataProd.manual : '/'}><a target={dataProd.manual ? '_blank' : ''}><button className={styles.btnManual}>Manual Vida Acidentes pessoais</button></a></Link>
                <Link passHref href={dataProd.manualTwo ? dataProd.manualTwo : '/'}><a target={dataProd.manualTwo ? '_blank' : ''}><button className={styles.btnManual}>Manual Vida Completo</button></a></Link>
              </div> :
              <Link passHref href={dataProd.manual ? dataProd.manual : '/'}><a target={dataProd.manual ? '_blank' : ''}><button className={styles.btnManual}>Manual do Segurado</button></a></Link>
            }
          </div>
        </div>
      }
      <div className="flex flex-col text-center dlg:w-11/12 w-12/12 mx-auto justify-self-center dlg:mt-12">
        <span className={styles.textFrequente}>Perguntas Frequentes</span>
        <span className={styles.textDuvida}>
          ficou<span className={styles.textDuvidaColor}> com alguma dúvida?</span>
        </span>
        <div>{nav}</div>
        <div className='mt-8 mb-12 text-center'>{counter < dataProd.questions.length ? <button onClick={verMais} className={styles.btnVerMais}>Ver mais +</button> : ''}</div>
      </div>
    </section >
  );
};
export default SecondHomeProducts;

